(function () {
  var MOVE_THRESHOLD = 10;

  function initLightbox(root) {
    var openers = root.querySelectorAll('[data-showroom-open]');
    var lightbox = root.querySelector('[data-showroom-lightbox]');
    if (!openers.length || !lightbox) return;

    var img = lightbox.querySelector('[data-showroom-img]');
    var labelEl = lightbox.querySelector('[data-showroom-label]');
    var nameEl = lightbox.querySelector('[data-showroom-name]');
    var linkEl = lightbox.querySelector('[data-showroom-link]');
    var items = [];
    var index = 0;
    var startX = 0;
    var startY = 0;
    var dragging = false;

    openers.forEach(function (el, i) {
      items.push({
        image: el.getAttribute('data-image') || '',
        alt: el.getAttribute('data-alt') || '',
        location: el.getAttribute('data-location') || '',
        url: el.getAttribute('data-location-url') || ''
      });

      el.addEventListener('pointerdown', function (evt) {
        startX = evt.clientX;
        startY = evt.clientY;
        dragging = false;
      });

      el.addEventListener('pointermove', function (evt) {
        if (Math.abs(evt.clientX - startX) > MOVE_THRESHOLD || Math.abs(evt.clientY - startY) > MOVE_THRESHOLD) {
          dragging = true;
        }
      });

      el.addEventListener('click', function (evt) {
        evt.preventDefault();
        if (dragging) return;
        openAt(i);
      });
    });

    function render() {
      var item = items[index];
      if (!item) return;
      img.src = item.image;
      img.alt = item.alt || item.location || '';
      var hasLocation = !!item.location;
      labelEl.hidden = !hasLocation && !item.url;
      if (item.url && item.location) {
        nameEl.hidden = true;
        linkEl.hidden = false;
        linkEl.href = item.url;
        linkEl.textContent = item.location;
      } else if (item.url) {
        nameEl.hidden = true;
        linkEl.hidden = false;
        linkEl.href = item.url;
        linkEl.textContent = 'View location';
      } else {
        linkEl.hidden = true;
        linkEl.removeAttribute('href');
        linkEl.textContent = '';
        nameEl.textContent = item.location;
        nameEl.hidden = !hasLocation;
      }
      lightbox.querySelector('[data-showroom-prev]').hidden = items.length < 2;
      lightbox.querySelector('[data-showroom-next]').hidden = items.length < 2;
    }

    function openAt(i) {
      index = i;
      render();
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = lightbox.querySelector('[data-showroom-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      img.removeAttribute('src');
    }

    function prev() {
      index = (index - 1 + items.length) % items.length;
      render();
    }

    function next() {
      index = (index + 1) % items.length;
      render();
    }

    lightbox.querySelectorAll('[data-showroom-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    lightbox.querySelector('[data-showroom-prev]').addEventListener('click', prev);
    lightbox.querySelector('[data-showroom-next]').addEventListener('click', next);

    document.addEventListener('keydown', function (evt) {
      if (lightbox.hidden) return;
      if (evt.key === 'Escape') close();
      if (evt.key === 'ArrowLeft') prev();
      if (evt.key === 'ArrowRight') next();
    });

    var media = lightbox.querySelector('[data-showroom-media]');
    var swipeX = 0;
    media.addEventListener('touchstart', function (evt) {
      swipeX = evt.changedTouches[0].clientX;
    }, { passive: true });
    media.addEventListener('touchend', function (evt) {
      var dx = evt.changedTouches[0].clientX - swipeX;
      if (dx > 50) prev();
      if (dx < -50) next();
    }, { passive: true });
  }

  document.querySelectorAll('.showroom-section').forEach(initLightbox);
})();
